/* eslint-disable */
export default (method, uri, data, headers, content_type, get_blob) => {
  method = method || 'GET';
  uri = uri || '';
  data = data || {};
  headers = headers || [];
  if (content_type !== false) {
    content_type = content_type || 'application/json';
  }
  if (data.constructor.name === 'FormData') {
    content_type = null;
  }
  return new Promise((resolve, reject) => {
    const xhttp = new XMLHttpRequest();
    if (get_blob) {
      xhttp.responseType = 'blob';
    }
    xhttp.onreadystatechange = function () {
      if (!((this.readyState === 1) || (this.readyState === 2) || (this.readyState === 3))) {
        let response;
        if (get_blob) {
          response = this.response
        } else {
          try {
            response = JSON.parse(this.response);
          } catch (e) {
            response = this.response
          }
        }
        const success = ((this.readyState === 4) && (this.status >= 200) && (this.status < 300));
        success ? resolve({'status': this.status, response}) : reject({'status': this.status, response});
      }
    };
    xhttp.open(method, uri, true);
    content_type && xhttp.setRequestHeader('Content-type', content_type);
    headers.forEach(function (header) {
      if (header['value'] !== null) {
        xhttp.setRequestHeader(header['name'], header['value']);
      }
    });
    if (content_type === null) {
      xhttp.send(data);
    } else {
      xhttp.send(data ? JSON.stringify(data) : null);
    }
  });
};